// eslint-disable-next-line import/no-extraneous-dependencies
import queryString from 'query-string'

export default props => {
    const { location } = props
    const { pathname, search } = location

    if (!pathname || !search) {
        return
    }

    if (pathname !== '/conversation') {
        return
    }

    const params = queryString.parse(props.location.search)

    return params
}
